import GenericCatalogPage from "./GenericCatalogPage";
import { TestTube } from "lucide-react";

export default function SampleTypes() {
  return (
    <GenericCatalogPage
      title="Tipos de Muestras"
      description="Administre los tipos de muestras"
      icon={TestTube}
      apiKey="sampleTypes"
      testIdPrefix="sample-type"
    />
  );
}
